import { pageSizes, pickerOptions, PAY_TYPE_OPTIONSS } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import { startDate } from '@/utils/filter';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import FooterControl from '@/components/FooterControl.vue';

export default {
  name: 'wait-fee',
  mixins: [pageSize],
  components: { HisAutocompleteSuggestions, FooterControl },
  data() {
    return {
      radio: '',
      pageSizes,
      pickerOptions,
      payTypes: PAY_TYPE_OPTIONSS,
      statTypes: [{
        value: 0,
        label: '全部',
      }, {
        value: 1,
        label: '收款',
      }, {
        value: 2,
        label: '退款',
      }, {
        value: 3,
        label: '还款',
      }],
      streamInfo: {
        netIncome: 0, // 净收入
        actualAmount: 0, // 实收金额
        payModeCash: 0, // 现金
        payModeAlipay: 0, // 支付宝
        payModeWeixin: 0, // 微信
        payModeBankCard: 0, // 银行卡
        payModeMedicalInsurance: 0, // 医保
        payModeCommercialInsurance: 0, // 商保
        payModeBalance: 0, // 余额
        payModeRest: 0, // 其它
      },
      tableData: [],
      total: 0, // 总数据条数
      time: [],
      query: {
        doctorId: null,
        payMode: 0,
        type: 0,
        drugName: '', // 患者姓名
        startTime: '',
        endTime: '',
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
      doctorOptions: [{
        doctorId: null,
        realName: '全部',
      }],
      chartData: {
        columns: ['日期', '净收入', '总收入', '总支出'],
        rows: [
          // { '日期': '2018-05-22', '净收入': 1, '总收入': 5, '总支出': 5000 },
          // { '日期': '2018-05-23', '净收入': 2, '总收入': 6, '总支出': 5 },
          // { '日期': '2018-05-24', '净收入': 3, '总收入': 7, '总支出': 5  }
        ],
      },
    };
  },
  methods: {
    // 药品名称检索
    querySearch(str, cb) {
      this.$api.drugControl.drugsNameList({ drugName: str }).then((res) => {
        if (Array.isArray(res.drugList) && res.drugList.length > 0) {
          cb(res.drugList);
        } else {
          cb([]);
        }
      });
    },
    // 选择药品名称
    selectHandle(e) {
      this.query.drugName = e.drugName;
      this.getTableData();
    },
    searchHandel(e) {
      this.query.drugName = e;
      this.getTableData();
    },
    // 刷新列表数据
    refresh() {
      this.getTableData();
    },
    // 获取列表信息
    getTableData(type) {
      if (type === 1) this.query.currentPage = 1;
      this.query.startTime = this.time ? this.time[0] : '';
      this.query.endTime = this.time ? this.time[1] : '';
      this.$api.statistic.listDetailed(this.query).then((res) => {
        console.log(res);
        this.tableData = res.list;
        this.total = res.totalSize;
      });
      this.getStream();
    },
    // 获取诊所医生
    getDoctors() {
      this.$api.statistic.getDoctors().then((res) => {
        this.doctorOptions = [...this.doctorOptions, ...res];
      });
    },
    // 获取流水统计
    getStream() {
      this.$api.statistic.getStream(this.query).then((res) => {
        console.log(res);
        this.streamInfo = res;
        this.chartData.rows = res.chartData.map(item => ({
          '日期': item.time,
          '净收入': item.netIncome,
          '总收入': item.totalSum,
          '总支出': item.expenditure,
        }));
        // this.netIncome = res.netIncome;
        // this.totalIncome = res.actualAmount;
        // this.expend = this.totalIncome - this.netIncome;
        // this.cash = res.payModeCash;
        // this.alipay = res.payModeAlipay;
        // this.wechat = res.payModeWeixin;
        // this.bankcard = res.payModeBankCard;
        // this.medicalInsurance = res.payModeMedicalInsurance;
        // this.commercialInsurance = res.payModeCommercialInsurance;
        // this.balance = res.payModeBalance;
        // this.others = res.payModeRest;
      });
    },
    // 跳转收费详情
    gotoFeeDetail(item) {
      this.$router.push({ name: 'feeDetail', query: { id: item } });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getTableData();
    },
  },
  mounted() {
    this.time = startDate(); // 设置默认日期
    this.getDoctors();
    this.getTableData();
  },
  filters: {
    getOperateType(type) {
      let opType = '';
      switch (type) {
        case 1: opType = '收款';
          break;
        case 2: opType = '退款';
          break;
        case 3: opType = '还款';
          break;
        default: opType = '';
          break;
      }
      return opType;
    },
  },
};
